import { CustomField } from "./customfield";

export class CustomSection {
    constructor(accountId, status, module) {
        this.accountId = accountId;
        this.id = null;
        this.sectionName = null;
        this.status = status;
        this.sectionOrder = 0;
        this.module = module;
        this.created = null;
        this.deviceType = null;
        this.titleTextColor = "#656565";
        this.titleBgColor = "#656565";
    }
    id: string;
    accountId: number;
    sectionName: string;
    status: boolean = true;
    sectionOrder: number;
    module: string;
    created: string;
    customFields: CustomField[] = [];
    deviceType: string;
    titleTextColor: string;
    titleBgColor: string;
}